import A11yDialog from 'a11y-dialog';
import { lockBody, unlockBody, BodyLockState } from '../helpers/lockBody';

/**
 * Initialize all modal dialogs on the page with body scroll locking.
 * Uses a11y-dialog's built-in trigger handling via data-a11y-dialog-show attributes.
 */
export function initModals(): void {
    const modalContainers = document.querySelectorAll('.modal-container');

    modalContainers.forEach((container: HTMLElement) => {
        let bodyLockState: BodyLockState | null = null;

        const dialog = new A11yDialog(container);

        dialog.on('show', () => {
            bodyLockState = lockBody();
        });

        dialog.on('hide', () => {
            if (bodyLockState) {
                unlockBody(bodyLockState);
                bodyLockState = null;
            }
        });
    });
}
